import { CommonModule, NgClass, NgFor, NgIf } from '@angular/common'
import { Component, OnInit } from '@angular/core'
import { FormsModule, ReactiveFormsModule, UntypedFormArray, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms'
import { KENDO_BUTTON } from '@progress/kendo-angular-buttons'
import { AddCommandDirective, CancelCommandDirective, CellTemplateDirective, ColumnComponent, CommandColumnComponent, DataBindingDirective, EditCommandDirective, EditTemplateDirective, FocusableDirective, GridComponent, GridToolbarFocusableDirective, KENDO_GRID, ToolbarTemplateDirective } from '@progress/kendo-angular-grid'
import { FormFieldComponent, MaskedTextBoxComponent, TextBoxDirective } from '@progress/kendo-angular-inputs'
import { LabelDirective } from '@progress/kendo-angular-label'
import { ClientServices } from '../../../@theme/services/clients.service'
import { TypesServices } from '../../../@theme/services/typeslist.service'
import { Sponsor, SponsorProductTypes } from '../../../models/adminModels'
import { GridEditorBaseComponent } from '../../reps/shared/rep-editor-base/grid-editor-base-component'
import { RepEditorStateService } from '../../reps/shared/rep-editor-state.service'
import { PHONE_MASK, PhonePipe } from '../../../@theme/pipes/phone.pipe'

@Component({
    selector: 'gd-sponsor',
    templateUrl: './sponsor.component.html',
    styleUrls: ['./sponsor.component.scss'],
    imports: [
        CommonModule,
        NgClass,
        KENDO_GRID,
        GridComponent,
        DataBindingDirective,
        ToolbarTemplateDirective,
        GridToolbarFocusableDirective,
        AddCommandDirective,
        KENDO_BUTTON,
        ColumnComponent,
        EditTemplateDirective,
        TextBoxDirective,
        FormsModule,
        ReactiveFormsModule,
        CellTemplateDirective,
        CommandColumnComponent,
        FocusableDirective,
        EditCommandDirective,
        CancelCommandDirective,
        NgIf,
        FormFieldComponent,
        LabelDirective,
        MaskedTextBoxComponent,
        NgFor,
        PhonePipe,
    ]
})
export class SponsorComponent
  extends GridEditorBaseComponent
  implements OnInit
{
  public sponsors: any[]
  public productTypes: any[]

  public phoneMask = PHONE_MASK

  get productTypeNestedControls(): UntypedFormArray {
    return this.formGroup.controls['productTypes'] as UntypedFormArray
  }

  constructor(
    typesService: TypesServices,
    clientService: ClientServices,
    formBuilder: UntypedFormBuilder,
    repEditorStateService: RepEditorStateService,
  ) {
    super(typesService, clientService, formBuilder, repEditorStateService)
  }

  ngOnInit() {
    this.initGrid()
    this.typesService.getProductTypes().subscribe((response) => {
      this.productTypes = response
    })
  }

  initGrid(): void {
    this.closeEditor()
    this.typesService.getSponsors().subscribe((response) => {
      this.sponsors = response
    })
  }

  saveHandler(event: any): void {
    const sponsor = new Sponsor(this.formGroup.value)
    const productTypeSelections = this.formGroup.controls['productTypes'].value
    for (let i = 0; i < this.productTypes.length; i++) {
      if (productTypeSelections[i]) {
        const sponsorProductType = new SponsorProductTypes()
        sponsorProductType.sponsorId = sponsor.sponsorId
        sponsorProductType.sponsorProductTypeId = 0
        sponsorProductType.productTypeId = this.productTypes[i].productTypeId
        sponsor.sponsorProductTypes.push(sponsorProductType)
      }
    }
    console.log(JSON.stringify(sponsor))
    this.typesService.submitSponsorUpdate(sponsor).subscribe(() => {
      this.initGrid()
    })
  }

  addHandler({ sender }: { sender: any }) {
    this.closeEditor()
    const newSponsor = new Sponsor(null)
    newSponsor.active = true
    newSponsor.sponsorId = 0
    this.formGroup = this.createFormGroup(newSponsor)
    // this.addHandlerShared({ sender }, )
  }

  removeHandler({ dataItem }: { dataItem: any }) {
    throw new Error('Method not implemented.')
  }

  public override editHandler({ sender, rowIndex, dataItem }) {
    this.closeEditor()
    this.formGroup = this.createFormGroup(dataItem)
    // this.editedRowIndex = rowIndex;
    // sender.editRow(rowIndex, this.formGroup);
  }

  public override cancelHandler() {
    this.closeEditor()
  }

  public override closeEditor() {
    this.formGroup = null
  }

  createFormGroup(sponsor: Sponsor): UntypedFormGroup {
    const productTypesArray = []
    for (const productType of this.productTypes) {
      if (
        sponsor.sponsorProductTypes &&
        sponsor.sponsorProductTypes.some(
          (pt) => pt.productTypeId == productType.productTypeId,
        )
      ) {
        productTypesArray.push(true)
      } else {
        productTypesArray.push(false)
      }
    }
    return this.formBuilder.group({
      sponsorId: [sponsor.sponsorId, Validators.required],
      sponsorName: [sponsor.sponsorName, Validators.required],
      attention: sponsor.attention,
      tradingFax: sponsor.tradingFax ?? null,
      insuranceFax: sponsor.insuranceFax ?? null,
      active: sponsor.active,
      productTypes: this.formBuilder.array(productTypesArray),
    })
  }
}
